
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.074 8.007v-.13c.003-.6.06-1.076.169-1.431.112-.355.271-.64.477-.855.205-.219.456-.42.75-.602.203-.126.383-.263.543-.412.162-.153.29-.322.382-.507.093-.19.14-.4.14-.632a1.24 1.24 0 00-.184-.68 1.248 1.248 0 00-.498-.448 1.484 1.484 0 00-.69-.16 1.52 1.52 0 00-.672.155c-.209.1-.383.252-.522.457-.136.202-.212.46-.228.77H.97c.016-.63.169-1.156.457-1.58A2.705 2.705 0 012.581.997 3.897 3.897 0 014.172.68c.633 0 1.19.111 1.67.333.485.222.86.539 1.13.95.271.407.407.891.407 1.451 0 .378-.061.716-.184 1.015-.12.298-.29.563-.512.795-.222.232-.486.44-.79.621a3.373 3.373 0 00-.662.518c-.169.178-.295.389-.378.63-.08.24-.12.535-.124.886v.13H3.074zm.865 3.102a1.06 1.06 0 01-.77-.318 1.047 1.047 0 01-.324-.775c0-.299.108-.554.323-.766a1.06 1.06 0 01.77-.318c.296 0 .55.106.766.318.219.212.328.467.328.766 0 .202-.051.386-.154.552-.1.165-.232.298-.397.397a1.044 1.044 0 01-.542.144z","fill":"#fff"}})])
          )
        }
      }
    